(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frame-mobile-menu"] && !Shopify.designMode) return;
  try {
    (function(){
  var mm = document.querySelector('.frame-mm'); if(!mm) return;
  var body = document.body, overlay = document.querySelector('.frame-mm__ov');
  var opener = null, background = [];
  var toggleSelector = '.mobileMenu-toggle, [data-mobile-menu]';
  var focusSelector = 'a[href], area[href], button, input, select, textarea, summary, iframe, [tabindex], [contenteditable="true"]';
  function isOpen(){ return body.classList.contains('frame-mm-open'); }
  function canFocus(el){
    return el && el.isConnected && !el.disabled && el.tabIndex >= 0 &&
      !el.closest('[inert], [hidden], [aria-hidden="true"]') && el.getClientRects().length > 0 &&
      window.getComputedStyle(el).visibility !== 'hidden';
  }
  function focus(el){
    if(!el) return;
    try{ el.focus({preventScroll:true}); }catch(e){ el.focus(); }
  }
  function focusable(){ return Array.prototype.filter.call(mm.querySelectorAll(focusSelector), canFocus); }
  function setToggles(expanded){
    document.querySelectorAll(toggleSelector).forEach(function(t){
      t.setAttribute('aria-controls', mm.id);
      t.setAttribute('aria-expanded', String(expanded));
    });
  }
  function isolateBackground(){
    // Isolate siblings at every ancestor, so the drawer also works inside a wrapper.
    var node = mm;
    while(node && node !== body){
      var parent = node.parentElement; if(!parent) break;
      Array.prototype.forEach.call(parent.children, function(el){
        if(el === node || el === overlay || (overlay && el.contains(overlay)) || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
        if(!background.some(function(saved){ return saved.el === el; })) background.push({el:el, inert:el.getAttribute('inert')});
        el.setAttribute('inert', '');
      });
      node = parent;
    }
  }
  function restoreBackground(){
    background.forEach(function(saved){
      if(saved.inert === null) saved.el.removeAttribute('inert');
      else saved.el.setAttribute('inert', saved.inert);
    });
    background = [];
  }
  function syncPanels(){
    mm.querySelectorAll('.frame-mm__panel, .frame-mm__sub').forEach(function(panel){
      var expanded = panel.parentElement.classList.contains('open');
      panel.toggleAttribute('inert', !expanded);
      panel.setAttribute('aria-hidden', String(!expanded));
    });
  }
  function openDrawer(trigger){
    if(isOpen()) return;
    opener = trigger && trigger.matches(toggleSelector) ? trigger : document.activeElement;
    mm.removeAttribute('inert');
    mm.setAttribute('aria-hidden', 'false');
    body.classList.add('frame-mm-open');
    setToggles(true);
    focus(mm.querySelector('.frame-mm__x') || mm);
    isolateBackground();
  }
  function closeDrawer(restoreFocus){
    var wasOpen = isOpen();
    body.classList.remove('frame-mm-open');
    body.classList.remove('menu_open');
    restoreBackground();
    setToggles(false);
    if(wasOpen && restoreFocus !== false){
      var target = canFocus(opener) ? opener : Array.prototype.find.call(document.querySelectorAll(toggleSelector), canFocus);
      focus(target);
    }
    if(mm.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur();
    mm.setAttribute('inert', '');
    mm.setAttribute('aria-hidden', 'true');
    opener = null;
    reset();
  }
  function reset(){
    mm.querySelectorAll('.frame-mm__item.open').forEach(function(i){ i.classList.remove('open'); });
    mm.querySelectorAll('.frame-mm__g.open').forEach(function(g){ g.classList.remove('open'); });
    mm.querySelectorAll('[aria-expanded="true"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
    syncPanels();
  }
  setToggles(false);
  mm.querySelectorAll('.frame-mm__l1, .frame-mm__l2').forEach(function(btn, index){
    var panel = btn.nextElementSibling;
    if(!panel) return;
    panel.id = panel.id || 'FrameMobileMenuPanel-' + index;
    btn.setAttribute('aria-controls', panel.id);
  });
  syncPanels();

  // OPEN: intercept the theme hamburger in the CAPTURE phase (before the theme's jQuery
  // document handler runs) so only OUR drawer opens. Works for dynamically-moved toggles.
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest(toggleSelector) : null;
    if(!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDrawer(t);
  }, true);

  // FALLBACK: convert the theme state and isolate any background widgets added while open.
  try{
    var mo = new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        if(muts[i].attributeName==='class' && body.classList.contains('menu_open') && !isOpen()){
          body.classList.remove('menu_open');
          openDrawer(document.activeElement);
          return;
        }
        if(muts[i].type==='childList' && isOpen()) isolateBackground();
      }
    });
    mo.observe(body, {attributes:true, attributeFilter:['class'], childList:true});
  }catch(e){}

  // Level 1 — single open; closing an L1 also resets its L2s
  mm.querySelectorAll('.frame-mm__l1').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.frame-mm__item'), isOpen = item.classList.contains('open');
      mm.querySelectorAll('.frame-mm__item.open').forEach(function(i){
        if(i!==item){ i.classList.remove('open');
          i.querySelectorAll('.frame-mm__g.open').forEach(function(g){ g.classList.remove('open'); });
          i.querySelectorAll('[aria-expanded="true"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); }); }
      });
      item.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      if(isOpen){ item.querySelectorAll('.frame-mm__g.open').forEach(function(g){ g.classList.remove('open'); });
        item.querySelectorAll('.frame-mm__l2[aria-expanded="true"]').forEach(function(b){ b.setAttribute('aria-expanded','false'); }); }
      syncPanels();
    });
  });
  // Level 2 — single open within its panel
  mm.querySelectorAll('.frame-mm__l2').forEach(function(btn){
    btn.addEventListener('click', function(){
      var g = btn.closest('.frame-mm__g'), panel = btn.closest('.frame-mm__panel'), isOpen = g.classList.contains('open');
      panel.querySelectorAll('.frame-mm__g.open').forEach(function(o){ if(o!==g){ o.classList.remove('open');
        o.querySelector('.frame-mm__l2').setAttribute('aria-expanded','false'); } });
      g.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
      syncPanels();
    });
  });
  // Direct links close the drawer without cancelling their default navigation.
  mm.querySelectorAll('[data-fmm-go]').forEach(function(a){ a.addEventListener('click', function(){ closeDrawer(false); }); });
  document.querySelectorAll('[data-fmm-close]').forEach(function(el){ el.addEventListener('click', function(){ closeDrawer(); }); });
  document.addEventListener('keydown', function(e){
    if(!isOpen()) return;
    if(e.key==='Escape'){ e.preventDefault(); e.stopPropagation(); closeDrawer(); return; }
    if(e.key!=='Tab') return;
    var items = focusable(), first = items[0], last = items[items.length-1];
    if(!items.length){ e.preventDefault(); focus(mm); return; }
    var index = items.indexOf(document.activeElement);
    if(e.shiftKey && (index === 0 || index === -1)){ e.preventDefault(); focus(last); }
    else if(!e.shiftKey && (index === items.length-1 || index === -1)){ e.preventDefault(); focus(first); }
  }, true);
  document.addEventListener('focusin', function(e){
    if(isOpen() && !mm.contains(e.target)) focus(focusable()[0] || mm);
  }, true);
  var desktop = window.matchMedia('(min-width:1025px)');
  function onDesktop(e){ if(e.matches && isOpen()) closeDrawer(); }
  if(desktop.addEventListener) desktop.addEventListener('change', onDesktop);
  else if(desktop.addListener) desktop.addListener(onDesktop);
})();
  } catch(e) { console.error(e); }
})();

})();
